import React from "react";
import { Link } from "gatsby";
import "./hero.scss";

export default () => {
  return (
    <div className="hero">
      <div className="hero-content">
        <h5>Welcome to</h5>
        <h1>Magdeline Academy</h1>
        <p>
          One of the Gujarat's leading OET preliminary provider institute recognized by OET Australia in Ahmedabad
        </p>
        <div className="hero-btn">
          <Link to="/testimonial">Our Students</Link>
          <Link to="/contact-us">Contact Us</Link>
        </div>
      </div>
    </div>
  );
};
